import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const createTender = createAsyncThunk("createTender", async (payload, { rejectWithValue }) => {
     try {
          const response = await axiosHttp.post("tms/tenders", payload);
          return response.data;
     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});

export const getTenderStatus = createAsyncThunk("getTenderStatus", async (_, { rejectWithValue }) => {
     try {
          const response = await axiosHttp.get("category/list?identifier=tenders&limit=10&page=1");
          return Array.isArray(response?.data?.data?.docs) ? response.data.data.docs : [];
     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});

const TenderCreateSlice = createSlice({
     name: "TenderCreateSlice",
     initialState: {
          tenderCreate: {
               isLoading: false,
               data: null,
               error: null,
          },
     },

     reducers: {
          resetTenderCreate: (state) => {
               state.tenderCreate = { isLoading: false, data: null, error: null };
          },
     },

     extraReducers: (builder) => {
          builder.addCase(createTender.pending, (state) => {
               state.tenderCreate.isLoading = true;
               state.tenderCreate.error = null;
          });
          builder.addCase(createTender.fulfilled, (state, action) => {
               state.tenderCreate.isLoading = false;
               state.tenderCreate.data = action.payload?.data;
          });
          builder.addCase(createTender.rejected, (state, action) => {
               state.tenderCreate.isLoading = false;
               state.tenderCreate.error = action.payload?.data;
          });

          builder.addCase(getTenderStatus.pending, (state) => {
               state.tenderStatusLoading = true;
               state.tenderStatusError = null;
          });
          builder.addCase(getTenderStatus.fulfilled, (state, action) => {
               state.tenderStatusLoading = false;
               state.tenderStatus = action.payload;
          });
          builder.addCase(getTenderStatus.rejected, (state, action) => {
               state.tenderStatusLoading = false;
               state.tenderStatusError = action.payload?.data;
          });
     },
});

export const { resetTenderCreate } = TenderCreateSlice.actions;
export const { resetTenderStatus } = TenderCreateSlice.actions;
export default TenderCreateSlice.reducer;